export class TournamentData {
  constructor({ jo_id, jo_number, jo_ymd, jo_type, stadium, players = [], winner_id }) {
    this.jo_id = jo_id || "";
    this.jo_number = jo_number || "";
    this.jo_ymd = jo_ymd || "";
    this.jo_type = jo_type || "";
    this.stadium = stadium || "";
    this.players = players; // 선수 배열
    this.winner_id = winner_id || null; // 승자가 정해진 데이터(2025 입력 결과)일 때만
  }

  static fromJson(json) {
    return new TournamentData({
      jo_id: json.jo_id || "",
      jo_number: json.jo_number || "",
      jo_ymd: json.jo_ymd || "",
      jo_type: json.jo_type || "",
      stadium: json.stadium || "",
      winner_id: json.winner_id || null,
      players: (json.players || []).map((p) => ({
        player_id: p.player_id || "",
        player_name: p.player_name || "",
        player_number: p.player_number || "",
        player_rank: p.player_rank || "",
        total_score: p.total_score || 0,
        special_point: p.special_point || 0,
        country: p.country || "",
        gender: p.gender || "",
      })),
    });
  }

  getPlayer(index) {
    return this.players[index] || null;
  }

  getPlayerText(index) {
    const player = this.getPlayer(index);
    if (!player) return "?";
    const rank = player.player_rank ? `${player.player_rank}위` : "?";
    return `${rank} ${player.player_name || "?"}`;
  }
}
